import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { NotificationService } from '../shared/services/notifications.service';
import { AddMedicalProviderComponent } from '../add-medical-provider/add-medical-provider.component';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-provider-card',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './provider-card.component.html',
  styleUrl: './provider-card.component.scss'
})
export class ProviderCardComponent {

  @Input() provider: any;
  @Input()role:any;
  isExpanded: boolean = false;
  avatarLoadError: boolean = false;
  @Input() actionHidden = false;

  constructor(private dialog: MatDialog, private restService: MemberInsurerRestService, private notificationService: NotificationService,
    private memberService: MemberInsurerServiceService
  ) { }

  ngOnInit(): void {
    // You might want to do initial data processing here if needed
    console.log(this.provider)
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  onStatusUpdate(status: boolean): void {
    this.restService.updateProviderStatus(this.provider.masterProviderId, status).subscribe({
      next: (response: string) => {
        this.notificationService.showNotification('Status updated sucessfully');
        this.memberService.setrefreshProviders();
      },
      error: (error) => {
        const message = error?.error?.message || 'An error occurred during status update.';
        this.notificationService.showNotification(message, 'error');
      }
    });
  }

  copiedEmail: string | null = null;
  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }


  onEditprovider() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '550px';
    dialogConfig.data = this.provider;
    this.dialog.open(AddMedicalProviderComponent, dialogConfig)
  }
}
